import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";

import TableLoader from "../../../components/admin/usable/TableLoader";
import { Switch } from "@mui/joy";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import ViewButton from "../../../components/admin/usable/actions/ViewButton";
import { useNavigate } from "react-router";
import { useClientAuth } from "../../../utils/useAuth";
import { hotelBooking } from "../../../api/client/bookingapi";
import HotelBookingDetail from "./HotelBookingDetail";

const HotelBooking = () => {
  const { company } = useClientAuth();
  const navigate = useNavigate();
  const [HotelData, setHotelData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [PageData, setPageData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    hotelBooking(
      setHotelData,
      Page,
      Limit,
      setPageData,
      setIsLoading,
      company?.id,
    );
  }, [Page, Limit, company?.id]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(HotelData);
    } else {
      const result = HotelData.filter((item) =>
        item.invoiceId.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, HotelData]);
  const grandTotal = FilteredData.reduce((sum, item) => {
    const stayoverTotal = (item.stayovers || []).reduce((acc, room) => {
      const discounted = Number(room.discountedPrice) || 0;
      const service = Number(room.serviceChargeAmount) || 0;

      return acc + (discounted + service);
    }, 0);

    return sum + stayoverTotal;
  }, 0);
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search by Invoice Id"
        />
        <div></div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Invoice ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tranx ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Rooms
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Guest
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Paid Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Nature
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {isLoading ? (
              <TableLoader colSpan={13} />
            ) : (
              <>
                {FilteredData.length > 0 ? (
                  <>
                    {FilteredData.map((item, index) => {
                      const totalAmount =
                        (item.stayovers || []).length > 0
                          ? (item.stayovers || []).reduce((acc, room) => {
                              return (
                                acc +
                                (room.discountedPrice +
                                  room.serviceChargeAmount)
                              );
                            }, 0)
                          : item.totalAmount || 0;
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.invoiceId}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.transactionId}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            <div className="w-full h-8 overflow-hidden rounded-lg">
                              <img
                                className="w-full h-full object-contain"
                                src={item.hotel?.hotelLogo}
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.hotel?.hotelName}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.rooms.length || 0} rooms
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.guests.length || 0} persons
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {totalAmount || 0} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.paidAmount || 0} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentStatus === "Paid"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-orange-100 text-orange-700"
                              } rounded text-xs`}
                            >
                              {item.paymentStatus === "Paid"
                                ? "Paid"
                                : "Unpaid"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentNature === "Partial"
                                  ? "bg-orange-100 text-orange-700"
                                  : "bg-green-100 text-green-700"
                              } rounded text-xs`}
                            >
                              {item.paymentNature === "Partial"
                                ? "Partial"
                                : "Full"}
                            </span>
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.createdAt.slice(0, 10)}
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <div className="flex gap-x-2">
                              <HotelBookingDetail item={item} />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan={13}
                      className="text-center py-5 text-gray-500 font-semibold"
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </>
            )}
            <tr className="bg-blue-100 font-semibold">
              <td className="px-4 py-3 text-sm text-gray-800" colSpan={7}>
                Total
              </td>

              <td className="px-4 py-3 text-md text-gray-800">
                {grandTotal || 0} BDT
              </td>

              <td className="px-4 py-3 text-md text-gray-800">
                {FilteredData.reduce(
                  (sum, item) => sum + (Number(item.paidAmount) || 0),
                  0,
                )}{" "}
                BDT
              </td>

              <td colSpan={4}></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {(Page - 1) * Limit + 1} to{" "}
          {(Page - 1) * Limit + HotelData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default HotelBooking;
